import { FC } from "react";
import { Alert } from "shared/components/Spor";

type MapAlertProps = {
  isError: boolean;
  hasNoResults: boolean;
  query: string;
};

const MapAlert: FC<MapAlertProps> = ({ isError, hasNoResults, query }) => {
  if (hasNoResults) {
    return (
      <Alert data-color="critical">
        Fant ingen materiell med ID &quot;{query}&quot;
      </Alert>
    );
  }
  if (isError) {
    return (
      <Alert data-color="critical">Noe gikk galt ved innlasting av data</Alert>
    );
  }

  return null;
};

export default MapAlert;
